import { memo } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CheckBoxIcon from "@mui/icons-material/CheckBox";

import { Finding, SourceLabel } from "stores/FindingStore";

import Actions from "./Actions";

// -----------------------------------------------------------------------------

const OrganizationFindingServiceRow = memo(
  function OrganizationFindingServiceRow({
    finding,
    onClose,
    isDashboard = false,
  }: OrganizationFindingServiceRowProps): JSX.Element {
    return (
      <Stack
        direction="row"
        sx={{ display: "flex", alignItems: "center", p: 2, pl: 1 }}
      >
        {!isDashboard && (
          <Box
            sx={{
              p: 1,
              cursor: onClose ? "pointer" : "default",
              display: "flex",
            }}
            onClick={() => onClose?.(finding.uuid)}
          >
            <CheckBoxIcon
              sx={{ color: onClose ? "primary.main" : "action.disabled" }}
            />
          </Box>
        )}
        <Typography variant="h6" flex={1} sx={isDashboard ? { ml: 1 } : {}}>
          {SourceLabel[finding.source] || "Unknown"}
        </Typography>
        <Actions finding={finding} />
      </Stack>
    );
  }
);

export default OrganizationFindingServiceRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingServiceRowProps {
  finding: Finding;
  onClose?: (uuid: string) => void;
  isDashboard?: boolean;
}
